<template>
  <div class="d-flex flex-wrap">
    <v-chip class="flex-1-0 mr-2" size="small" label>
      <v-icon icon="mdi-calendar-text" start></v-icon>
      {{ getDate(note.updated_at) }}
    </v-chip>
    <v-chip label size="small" class="mx-2">
      <v-icon icon="mdi-content-cut" start></v-icon>
      {{ note.salon_id }}</v-chip
    >
  </div>
</template>

<script>
export default {
  name: "NoteHeader",
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getDate(isoStr) {
      const date = new Date(isoStr);
      const day = date.getUTCDate();
      const month = date.getUTCMonth() + 1;
      const year = date.getUTCFullYear();

      return day + "/" + month + "/" + year;
    },
  },
};
</script>
